import { SchoolCertificate } from '@pflegia/types/common/candidate/school-certificate';

export { /** @deprecated Import from @pflegia/types/common instead. */ SchoolCertificate };
